import type { DriveStep } from 'driver.js'

export const agentBuilderTour: Array<DriveStep> = [
  {
    element: '#agent-flow-canvas',
    popover: {
      title: 'Your agent, on a canvas',
      description:
        'Every model in this agent is a node. Drag to rearrange, scroll to zoom, and click any node to open its settings on the right.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '#agent-coordinator-node',
    popover: {
      title: 'The coordinator answers everything',
      description:
        'Required, and always first: it reads the request, decides whether a specialist is needed, and owns the conversation. Open <strong>Settings</strong> on the node to choose its model, a fallback and custom rules.',
      side: 'right',
    },
  },
  {
    element: '#agent-add-specialist',
    popover: {
      title: 'Add a specialist',
      description:
        'Specialists are pre-built experts — researcher, coder, reviewer and more. Each one gets its own model, so you can pay for a strong model only where it matters.',
      side: 'right',
    },
  },
  {
    element: '#agent-flow-legend',
    popover: {
      title: 'Advise vs Delegate — the setting that matters most',
      description:
        '<strong>Advises</strong>: the specialist reports back and the coordinator writes the final reply, blending it with everything else it knows. <strong>Delegates</strong>: the specialist\'s answer goes to the user exactly as written, with nothing added. Switch it with the <strong>Replies</strong> toggle on each specialist node.',
      side: 'right',
      align: 'start',
    },
  },
  {
    element: '#stack-id',
    // Below md the settings panel is a closed overlay, so the Stack ID field
    // is in the DOM but display:none. Open the panel from the header toggle
    // and let driver re-measure once React has committed the change.
    onHighlightStarted: (_element, _step, { driver: instance }) => {
      const field = document.getElementById('stack-id')
      if (!field || field.offsetParent !== null) return

      const toggle = document.getElementById('agent-settings-toggle')
      if (!toggle || toggle.offsetParent === null) return

      toggle.click()
      window.setTimeout(() => instance.refresh(), 100)
    },
    popover: {
      title: 'Give it a Stack ID',
      description:
        'This is the name you pass as the <code>model</code> field when you call the API. Lowercase letters, numbers, dashes and dots — for example <code>code-review-strict</code>.',
      side: 'left',
    },
  },
  {
    element: '#agent-save-btn',
    popover: {
      title: 'Save and start calling it',
      description:
        'Saving makes the Stack ID live straight away. Come back any time to add specialists or change how one replies — callers keep using the same Stack ID.',
      side: 'bottom',
      align: 'end',
    },
  },
]
